<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div class="card border-top mt-2">
        <div class="card-body">
            <h4 class="page-title mt-0">{{'account.edit-card' | translate}}</h4>
            <hr>
            <strong>{{'account.card_information' | translate}}:</strong><br>
            <form class="w-100" [formGroup]="editCardForm" name="form" (ngSubmit)="editCard()">
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-2">
                        <label for="name">{{'account.card_name' | translate}}<span class="error">*</span></label>
                        <input id="name" type="text" formControlName="name" class="form-control" maxlength="26"
                                [ngClass]="{ 'is-valid': name['valid'], 'is-invalid': name['invalid'] }"  />
                        <ng-container *ngIf="editCardForm.get('name').invalid && (editCardForm.get('name').touched || editCardForm.get('name').dirty)">
                            <div *ngIf="editCardForm.get('name').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('name').hasError('pattern')" class="error">
                                {{'error.card_name' | translate}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-2">
                        <label for="last4" class="mb-0">{{'account.last4' | translate}}<span class="error">*</span></label>
                        <input id="last4" formControlName="last4" type="text" class="form-control" maxlength="24" disabled />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-2">
                        <label for="exp_month">{{'account.exp_month' | translate}}<span class="error">*</span></label>
                        <input id="exp_month" type="text" formControlName="exp_month" class="form-control" maxlength="2"
                                [ngClass]="{ 'is-valid': exp_month['valid'], 'is-invalid': (exp_month['invalid'] || (editCardForm.errors&&!editCardForm.errors.validator)) }" />
                        <ng-container *ngIf="(editCardForm.errors&&!editCardForm.errors.validator) || (editCardForm.get('exp_month').invalid && (editCardForm.get('exp_month').touched || editCardForm.get('exp_month').dirty || formSubmitted ))">
                            <div *ngIf="editCardForm.get('exp_month').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('exp_month').hasError('pattern')" class="error">
                                {{'error.month' | translate}}
                            </div>
                            <div *ngIf="(editCardForm.errors&&!editCardForm.errors.validator)" class="error">
                                {{'general.invalid_date' | translate}}
                            </div>
                        </ng-container>
                        <div id="invalid_date" class="error" hidden></div>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-2">
                        <label for="exp_year">{{'account.exp_year' | translate}}<span class="error">*</span></label>
                        <input id="exp_year" type="text" formControlName="exp_year" class="form-control" minlength="4" maxlength="4"
                                [ngClass]="{ 'is-valid': exp_year['valid'], 'is-invalid': (exp_year['invalid'] || (editCardForm.errors&&!editCardForm.errors.validator)) }" />
                        <ng-container *ngIf="editCardForm.get('exp_year').invalid && (editCardForm.get('exp_year').touched || editCardForm.get('exp_year').dirty || formSubmitted)">
                            <div *ngIf="editCardForm.get('exp_year').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('exp_year').hasError('pattern')" class="error">
                                {{'error.numbers_only' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('exp_year').hasError('minlength')" class="error">
                                {{'error.four_digits' | translate}}
                            </div>
                        </ng-container>
                    </div>
                </div>

                <hr class="mt-3">
                <strong>{{'account.billing_address' | translate}}: </strong>
                <div class="row mt-2">
                    <div class="col-sm-12 col-md-8">
                        <label for="address_line1">{{'user.address' | translate}}<span class="error">*</span></label>
                        <input id="address_line1" type="text" formControlName="address_line1" class="form-control" maxlength="100"
                                [ngClass]="{ 'is-valid': address_line1['valid'], 'is-invalid': address_line1['invalid'] }"  />
                        <ng-container *ngIf="editCardForm.get('address_line1').invalid && (editCardForm.get('address_line1').touched || editCardForm.get('address_line1').dirty)">
                            <div *ngIf="editCardForm.get('address_line1').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('address_line1').hasError('pattern')" class="error">
                                {{'error.address' | translate}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <label for="address_city">{{'user.city' | translate}}<span class="error">*</span></label>
                        <input id="address_city" type="text" formControlName="address_city" class="form-control" maxlength="50"
                                [ngClass]="{ 'is-valid': address_city['valid'], 'is-invalid': address_city['invalid'] }"  />
                        <ng-container *ngIf="editCardForm.get('address_city').invalid && (editCardForm.get('address_city').touched || editCardForm.get('address_city').dirty)">
                            <div *ngIf="editCardForm.get('address_city').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('address_city').hasError('pattern')" class="error">
                                {{'error.address' | translate}}
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-4">
                        <label for="address_state" class="mt-2">{{'user.state' | translate}}<span class="error">*</span></label>
                        <input id="address_state" type="text" formControlName="address_state" class="form-control" maxlength="50"
                                [ngClass]="{ 'is-valid': address_state['valid'], 'is-invalid': address_state['invalid'] }"  />
                        <ng-container *ngIf="editCardForm.get('address_state').invalid && (editCardForm.get('address_state').touched || editCardForm.get('address_state').dirty)">
                            <div *ngIf="editCardForm.get('address_state').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('address_state').hasError('pattern')" class="error">
                                {{'error.address' | translate}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <label for="address_country" class="mt-2" for="address_country">{{'user.country' | translate}}<span class="error">*</span></label>
                        <input id="address_country" type="text" class="form-control" maxlength="100" formControlName = "address_country"
                        [ngClass]="{ 'is-valid': address_country['valid'], 'is-invalid': address_country['invalid'] }"  />
                        <ng-container *ngIf="editCardForm.get('address_country').invalid && (editCardForm.get('address_country').touched || editCardForm.get('address_country').dirty)">
                            <div *ngIf="editCardForm.get('address_country').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('address_country').hasError('pattern')" class="error ta-left">
                                {{'error.address' | translate}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <label for="address_zip" class="mt-2">{{'user.zip_code' | translate}}<span class="error">*</span></label>
                        <input id="address_zip" type="text" formControlName="address_zip" class="form-control" maxlength="5"
                                [ngClass]="{ 'is-valid': address_zip['valid'], 'is-invalid': address_zip['invalid'] }" />
                        <ng-container *ngIf="editCardForm.get('address_zip').invalid && (editCardForm.get('address_zip').touched || editCardForm.get('address_zip').dirty)">
                            <div *ngIf="editCardForm.get('address_zip').hasError('required')" class="error">
                                {{'general.required_field' | translate}}
                            </div>
                            <div *ngIf="editCardForm.get('address_zip').hasError('pattern')" class="error">
                                {{'error.numbers_only' | translate}}
                            </div>
                        </ng-container>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-right">
                        <button type="button" (click)="cancelEdit()" class="btn btn-red btn-h-red mr-2" title="{{'general.cancel' | translate}}">
                            {{'general.cancel' | translate}}
                        </button>
                        <input type="submit" class="btn btn-green btn-h-green" title="{{'general.update' | translate}}"
                                value="{{'general.update' | translate}}">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <div id="external_error" class="error"></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
